<template>
    <grid-layout
        :layout="widgets"
        :col-num="col_num"
        :row-height="100"
        :is-mirrored="false"
        :vertical-compact="true"
        :margin="[10, 10]"
        :use-css-transforms="true"
        :is-draggable="widgetSettingsVisible"
        :is-resizable="widgetSettingsVisible"
        @layout-updated="layoutUpdatedEvent"
    >
      <grid-item v-for='widget in widgets' :key='widget.id' v-if="!section_id || widget.sectionIds.includes(section_id)"
              :x="widget.x"
              :y="widget.y"
              :w="widget.w"
              :h="widget.h"
              :i="widget.id"
              @moved="movedWidget"
              @move="moveWidget"
              @resize="resizeWidget"
              @resized="resizedWidget"
              v-on:mouseover.native="zUp(widget.id)"
              v-on:mouseleave.native="zDown(widget.id)"
      >
        <component @deleteWidget='loadWidgets(section_id)' :is='widget.type' :widget='widget' :print="print" />
      </grid-item>
    </grid-layout>
</template>
<script>
    import { mapGetters } from 'vuex'
    import VueGridLayout from 'vue-grid-layout'
    import NumberWidget from './widgets/NumberWidget'
    import DoughnutWidget from './widgets/DoughnutWidget'
    import LinechartWidget from './widgets/LinechartWidget'
    import BarWidget from './widgets/BarWidget'
    import TableWidget from './widgets/TableWidget'
    import GaugeWidget from './widgets/GaugeWidget'
    import GalleryWidget from './widgets/GalleryWidget'
    import FunnelWidget from './widgets/FunnelWidget'
    export default {
      name: 'DashboardGrid',
      components: {
          VueGridLayout,
          NumberWidget,
          DoughnutWidget,
          LinechartWidget,
          BarWidget,
          TableWidget,
          GaugeWidget,
          GalleryWidget,
          FunnelWidget
      },
      props: ['print', 'section_id', 'widgets', 'is_draggable', 'is_resizable', 'col_num'],
      created () {
        this.$eventBus.$on('updateWidgetHeight', (id, rows) => this.updateWidget(id, rows))
      },
      methods: {
        updateWidget (id, rows) {
          let updatedWidget = this.widgets.find((w) => {return w.id === id})
          let index = this.widgets.findIndex((w) => {return w.id === id})
          updatedWidget.h = rows/1.9
          this.widgets.splice(index,1,updatedWidget)
          this.$nextTick(() => this.$eventBus.$emit('readyToPrint'))
        },

        loadWidgets (sectionId) {
          this.$eventBus.$emit('reloadWidgets', sectionId)
        },

        moveWidget (id, newX, newY) {
          var self = this
          this.widgets.forEach(function(widget, i){
            if (widget.id == id) {
              self.widgets[i].x = newX
              self.widgets[i].y = newY
              return true
            }
          })
        },

        movedWidget (id, newX, newY) {
          this.$http.patch('/dashboards/'+ this.$route.params.id +'/widgets/' + id, {x: newX, y: newY})
            .then(response => console.log(response.status))
            .catch(() => this.error("Couldn't move"))
        },

        resizeWidget (id, newH, newW) {
          var self = this
          this.widgets.forEach(function(widget, i){
            if (widget.id == id) {
              self.widgets[i].w = newW
              self.widgets[i].h = newH
              return true
            }
          })
        },

        resizedWidget (id, newH, newW) {
          this.$http.patch('/dashboards/'+ this.$route.params.id +'/widgets/' + id, {w: newW, h: newH})
            .then(response => console.log(response.status))
            .catch(() => this.error("Couldn't resize"))
        },

        layoutUpdatedEvent (widgets) {
          let self = this
          widgets.forEach(function(widget){
            self.movedWidget(widget.id, widget.x, widget.y)
          })
        },

        error (text) {
          this.$toasted.show(text, {
            duration: 3000,
            position: 'top-center',
            theme: "bubble"
          })
        },

        zUp (id) {
          for (var i = 0; i < this.widgets.length; i++) {
            if (this.widgets[i].id == id) {
              var item = document.getElementById(`widgetppt` + id)
              item.parentElement.style.zIndex = '99'
            }
          }
        },

        zDown (id) {
          for (var i = 0; i < this.widgets.length; i++) {
            if (this.widgets[i].id == id) {
              var item = document.getElementById(`widgetppt` + id)
              item.parentElement.style.zIndex = '11'
            }
          }
        }

      },
      computed: {
        ...mapGetters(['widgetSettingsVisible'])
      }

    }
</script>
<style scoped>
  /* IE fix */
#card-chart-01, #card-chart-02 {
  width: 100% !important;
}
.card {
  margin-bottom: 0;
  height: 100%;
  overflow: auto;
}
.card .table-responsive-sm {
    overflow: auto;
}
.bottom-nav a {
  color: #58b2cd;
  cursor: pointer;
  margin: 30px auto;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
.bottom-nav .left {
  float: left;
}
.bottom-nav .right {
  float: right;
  padding-right: 50px;
  text-align: right;
}
.bottom-nav .left:hover {
  -webkit-transform: translateX(-5px);
  transform: translateX(-5px);
  color: #47889c;
}
.bottom-nav .right:hover {
  -webkit-transform: translateX(5px);
  transform: translateX(5px);
  color: #47889c;
}
@media (min-width: 786px) {
  .bottom-nav .left {
    padding-left: 50px;
  }
}
</style>
<style>
  .tab-content {
    background: transparent;
    border: none;
  }
  .tab-content .tab-pane {
    padding: 0;
  }
  .nav-tabs .nav-link.active, .nav-tabs .nav-link.active:focus {
    background: transparent;
    border-color: transparent;
  }
  .nav-tabs .nav-link:hover {
    color: #3493B2;
    border-bottom-color: transparent;
  }
  .nav-tabs .nav-link:after {
    content: "";
    display: block;
    width: calc(100% + 30px);
    margin-left: -15px;
    transform: translateY(8px);
    height: 3px;
    background-color: transparent;
    position: relative;
    -webkit-transition: all 0.3s ease;
		-moz-transition: all 0.3s ease;
		-o-transition: all 0.3s ease;
		transition: all .3s ease;
  }
  .nav-tabs .nav-link.active:after {
    content: "";
    display: block;
    width: calc(100% + 30px);
    margin-left: -15px;
    transform: translateY(8px);
    height: 3px;
    background-color: #3493B2;
    position: relative;
    -webkit-transition: all 0.3s ease;
		-moz-transition: all 0.3s ease;
		-o-transition: all 0.3s ease;
		transition: all .3s ease;
 }
 .modal-body .nav-tabs {
    margin-bottom: 15px;
  }
  .chartjs-tooltip {
    position: fixed;
  }
  .vue-grid-item {
    z-index: 11;
  }
</style>
